import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/core/services/data.service';

import { LANGUAGES } from 'src/app/core/config/config.constants';
import { MultiLangField } from './multi-language';

@Component({
  selector: 'multilang-input',
  templateUrl: './multilang-input.component.html',
  styleUrls: ['./multilang-input.component.scss']
})
export class MultilangInputComponent implements OnInit {
  @ViewChild('inputField') inputField!: ElementRef<HTMLInputElement>;
  @Input() field: MultiLangField; 
  @Input() isRequired: boolean = false;
  @Output() fieldChange: EventEmitter<any> = new EventEmitter<any>();

  selectedLang: string;
  labelField: string = '';
  
  constructor(private _translateService: TranslateService,
    private dataService: DataService
  ) {
    this._translateService.setDefaultLang(this.dataService.getLanguage())
    this.selectedLang = localStorage.getItem('language') || 'en';
  }
  
  ngOnInit(): void {
    this.getFieldLabel();
  }

  getFieldLabel() {
    const raw = this._translateService.instant('configs.' + this.field.fieldTitle.toLowerCase());
    this.labelField = this.isRequired ? raw + ' *' : raw;
  }

  getLabel(): string {
    const item = this.field.labels.find(l => l.lang === this.selectedLang);
    return item ? item.value : '';
  }

  setLabel(event: any) {
    const value = event.target.value;
    let item = this.field.labels.find(l => l.lang === this.selectedLang)!;
    item.value = value;

    this.fieldChange.emit(this.field);
  }

  getImage(lang: string): string {
    return '../../../../' + LANGUAGES.find(l => l.key === lang)?.img!;
  }

  onLangChange(lang: string) {
    this.selectedLang = lang;
    this.getFieldLabel();
    // Focus e seleziona il testo
    setTimeout(() => {
      if (this.inputField) {
        this.inputField.nativeElement.focus();
        //this.inputField.nativeElement.select();
      }
    }, 0);
  }

}